module.exports = __webpack_public_path__ + "static/img/a128.01312ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a128.jpg
// module id = Ad4v
// module chunks = 0